import { Component, OnInit,OnChanges,SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import { Observable } from 'rxjs';
import { AppSettings } from 'src/app/app.constant';
import { OrganisationService } from 'src/app/shared/services/organisation.service';
import { ExaminationService } from 'src/app/shared/services/examination.service';

@Component({
  selector: 'app-transcript',
  templateUrl: './transcript.component.html',
  styleUrls: ['./transcript.component.css']
})

export class TranscriptComponent implements OnInit {
  public resultdata:any;
  Exams:any;
  EnrollmentNo:string;
  message:any;
  msgData:any;
  msgDatas:any="";
  htmldata:any="";
  institutionlogo:any;
  organisationlogo:any;
  organisationName:any;
  credit:any;
  post:any;
  examdata:any;
  TotalGradePoint:any;
  datahtml:any;
  Firstname:any="";

  @ViewChild('content') content: ElementRef;
  
  constructor(  
            private _examinationservice:ExaminationService,
            private _organisationservice:OrganisationService,  ) { }

  ngOnInit() {
            this.getOrganisation();
            this.getBatchEnrollmentNo();
  }
     
  getOrganisation() {
    this._organisationservice.getAllOrganisation(AppSettings.API_ENDPOINT+AppSettings.GetAllOrganisation)
      .subscribe(result =>{
          this.resultdata=result;
          this.organisationlogo='http://localhost:6064/logos/Organisation/'+this.resultdata[0].Logo;
          this.organisationName=this.resultdata[0].OrganisationName;
      if(!result){
          return;    }
  });
  }

  getBatchEnrollmentNo() {  
    var tmpEnrolmentNo;
    var tmpEnrolmentNo1;
    var k=0;
    this._examinationservice.currentMessage
    .subscribe(
      message=>{
        this.msgData=message;
        console.log(this.msgData);

        // for ( var i=0;i < this.msgData.length;i++) {  
        //   if(tmpEnrolmentNo==this.msgData[i].EnrolmentNo) {
        //   }
        //   else {
        //     tmpEnrolmentNo= this.msgData[i].EnrolmentNo;
        //     tmpEnrolmentNo1=this.msgData[i].EnrolmentNo;
        //     k=k+1;
            var o={
              EnrolmentNo:this.msgData,
              // FK_ModuleID:this.msgData[i].FK_ModuleID,
              // PK_ProgramID:this.msgData[i].PK_ProgramID,
              // PK_BatchID:this.msgData[i].PK_BatchID,
                  }
            this.GetResultList(o,k);
        //   }
        // }
      });
  }

  public GetResultList(o,k) {
    this.post=JSON.stringify(o);
    
    this._examinationservice.getResultByEnrollmentNo(AppSettings.API_ENDPOINT+AppSettings.GetExamByEnrollmentNo,this.post)
    .subscribe(result =>{
        this.msgDatas=result;
        console.log( this.msgDatas[0].FirstName );
        this.Firstname=this.msgDatas[0].FirstName ;
          var j=0;
          var tempval;
          this.htmldata="";
          var gradePoint=0;
          var gradePoint1=0;
          var gradePoint2=0;
          var credit=0;
          var GP=0;
          var totalGP=0;
          var totalGP1=0;
          var toralcredit=0;
          var totalgradePoint=0;
          var totalcredits=0;
          this.institutionlogo='http://localhost:6064/Uploads/images/'+this.msgDatas[0].Logo;
          this.htmldata=` <table class="result-table noborder" id="contentToConvert${k}" >
              <tr><td style="border: none;text-align: center" colspan="4">
              <table width="100%" class="noborder">
                <tr>
                  <td class="center"><img class="imgbox" src="${this.organisationlogo}"></td>
                  <td class="center"><h4>${this.organisationName}</h4>
                    <p>In collaboration with</p>
                    <h4>${this.msgDatas[0].InstitutionName}</h4>
                    <h3>${this.msgDatas[0].BatchName}</h3>
                    <h3>TRANSCRIPT OF ACADEMIC RECORD</h3>
                </td>
                <td class="center"><img class="imgbox" src="${this.institutionlogo}"> </td></tr> 
              </table>
             </td>
          </tr>
          <tr> 
              <td colspan="4"><p>Name : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${this.Firstname + this.msgDatas[0].LastName }</b><br>
                   ID / Passport :  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${this.msgDatas[0].PassportNo }</b><br>
                   Enrolment Number:   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${this.msgDatas[0].EnrolmentNo  }</b></p><br>
              </td>
          </tr>
          <tr>
              <td class="tenpercent"><b>CODE</b></td>
              <td ><b>MODULE</b></td>
              <td class="tenpercent"><b>CREDITS</b></td>
              <td class="tenpercent"><b>GRADE</b></td>
          </tr> `

          for ( var i=0;i < this.msgDatas.length;i++) {    
            tempval= this.msgDatas[i].ExamSection;
           
            this.htmldata= this.htmldata+ `<tr><td colspan="4" class='tblcolumn'><b>Exam Session :  ${this.msgDatas[i].ExamSection}</b>&nbsp;<b>${this.msgDatas[i].ExamYear}</b></td></tr>`;
              for (j;j< this.msgDatas.length;j++) {
              i=j;
              if(tempval==this.msgDatas[j].ExamSection) {
                if(this.msgDatas[j].Grade !="D" && this.msgDatas[j].Grade !="D+" && this.msgDatas[j].Grade !="E")
                {
                //  console.log(this.msgData[j].Grade);
                }
                else
                {
                  //console.log(this.msgData[j].Grade);
                }
                  credit=this.msgDatas[j].Credit;
                  toralcredit=toralcredit+credit;
                  // console.log(this.msgData[j].Grade);
                  // console.log(this.msgData[j].credit);
                  // console.log(this.msgData[j].toralcredit);
                  GP=this.msgDatas[j].GradePoint;
                  totalGP=credit*GP;
                  totalGP1=totalGP1+totalGP;
                  var hdata=`<tr><td>${this.msgDatas[j].SubjectCode}</td><td>${this.msgDatas[j].SubjectName}</td><td>${this.msgDatas[j].Credit}</td><td>${this.msgDatas[j].Grade}</td></tr>`;
                  this.htmldata= this.htmldata+hdata;
                  gradePoint2=gradePoint2+totalGP1;

                }
              else  {
                  i=j-1;
                  tempval= this.msgDatas[j].ExamSection;
                  break;
                }
              }
              totalcredits=totalcredits+toralcredit;
                totalgradePoint=totalgradePoint+totalGP1;
                this.htmldata= this.htmldata+ `<tr><td colspan=4><b>GPA :  ${(gradePoint2/toralcredit).toFixed(2)}</b></td></tr>`;
                //this.htmldata= this.htmldata+ `<tr><td>${totalgradePoint}</td><td>${totalcredits}</td><td>${toralcredit}</td><td>${totalGP1}</td><td colspan=4><b>GPA :  ${gradePoint2/toralcredit}</b></td></tr>`;
                gradePoint2=0
                toralcredit=0;
                totalGP1=0;
            } 
            this.htmldata= this.htmldata+ `<tr><td colspan="4"><b>CGPA : ${(totalcredits/totalgradePoint).toFixed(2)}</b></td></tr><hr>
            </div> 
                    <tr style="border: none">
                        <td colspan="4"  >
                          <b>FINAL RESULT: COMPLETED</b><br>
                          <b>OVERALL:</b><br>
                          <b>END OF THE UNDERGRADUATE STUDY</b><br>
                          <b>END OF THE TRANSCRIPT</b><br>
                        </td>
                        </tr>
                    <tr>
                  <td colspan="4" class="center"><br>
                    <table class="gradetable" >
                        <tr>
                          <td colspan="2" class="center">
                                <b>GRADES</b>
                          </td>
                        </tr>
                        <tr>
                          <td  class="center">
                            0.00-39.00%-FAIL(E)<br>
                            45.00-49.00%-BARE FAIL(D+)<br>
                            60.00-64.00%-PASS(C+)<br>
                            70.00-74.00%-MERIT(B+)<br>
                            86.00-100.00%-DISTINCTION(A+)<br>
                          </td>
                          <td class="center" >
                            40.00-44.00%-FAIL(D)<br>
                            50.00-59.00%-BARE PASS(C)<br>
                            65.00-69.00%-CREDIT(B)<br>
                            75.00-85.00%-DISTINCTION(A)<br>
                          </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr style="border: none"><td colspan="2" style="border: none"><br><br><br><br><b>Managing Director(GUC)</b></td><td colspan="2" style="border: none"><br><br><br><br><b>Vice Chancellor (CHOU)<b></td></tr>
                <tr style="border: none"><td colspan="4" class="center">Date Of Issue : </td></tr>
          </table>  `;
            this.datahtml= this.datahtml+this.htmldata;
          });
      }

  getval(){
    this._examinationservice.currentMessage
      .subscribe(
        message=>{
          this.msgData=message;
          var j=0;
          var tempval;
          this.htmldata="";
          var gradePoint=0;
          var gradePoint1=0;
          var gradePoint2=0;
          var credit=0;
          var GP=0;
          var totalGP=0;
          var totalGP1=0;
          var toralcredit=0;
          var totalgradePoint=0;
          var totalcredits=0;
          var GradeG;
          for ( var i=0;i < this.msgData.length;i++) {    
            tempval= this.msgData[i].ExamSection;
            this.institutionlogo='http://localhost:6064/Uploads/images/'+this.msgData[0].Logo;
            this.htmldata= this.htmldata+ `<tr><td colspan="4" class='tblcolumn'><b>Exam Session -  ${this.msgData[i].ExamSection}</b></td></tr>`;
              for (j;j< this.msgData.length;j++) {
              i=j;
              if(tempval==this.msgData[j].ExamSection) {
                if(this.msgData[j].Grade !="D" && this.msgData[j].Grade !="D+" && this.msgData[j].Grade !="E")
                {
                  console.log(this.msgData[j].Grade);
                }
                else
                {
                  //console.log(this.msgData[j].Grade);
                }
                  credit=this.msgData[j].Credit;
                  toralcredit=toralcredit+credit;

                  GP=this.msgData[j].GradePoint;
                  totalGP=credit*GP;
                  totalGP1=totalGP1+totalGP;
                  var hdata=`<tr><td>${this.msgData[j].SubjectCode}</td><td>${this.msgData[j].SubjectName}</td><td>${this.msgData[j].Credit}</td><td>${this.msgData[j].Grade}</td></tr>`;
                  this.htmldata= this.htmldata+hdata;
                  gradePoint2=gradePoint2+totalGP1;
                }
              else  {
                  i=j-1;
                  tempval= this.msgData[j].ExamSection;
                  break;
                }
              }
              totalcredits=totalcredits+toralcredit;
                totalgradePoint=totalgradePoint+totalGP1;
                this.htmldata= this.htmldata+ `<tr><td colspan=4><b>GPA :  ${(gradePoint2/toralcredit).toFixed(2)}</b></td></tr>`;
                //this.htmldata= this.htmldata+ `<tr><td>${totalgradePoint}</td><td>${totalcredits}</td><td>${toralcredit}</td><td>${totalGP1}</td><td colspan=4><b>GPA :  ${gradePoint2/toralcredit}</b></td></tr>`;
                gradePoint2=0
                toralcredit=0;
                totalGP1=0;
            } 
            this.htmldata= this.htmldata+ `<tr><td><b>CGPA : ${(totalcredits/totalgradePoint).toFixed(2)}</b></td></tr>`;
    });
}


















    


//   getBase64ImageFromURL(url: string) {
//     return Observable.create((observer: Observer<string>) => {
//       // create an image object
//       let img = new Image();
//       img.crossOrigin = 'Anonymous';
//       img.src = url;
//       if (!img.complete) {
//           // This will call another method that will create image from url
//           img.onload = () => {
//           observer.next(this.getBase64Image(img));
//           observer.complete();
//         };
//         img.onerror = (err) => {
//            observer.error(err);
//         };
//       } else {
//           observer.next(this.getBase64Image(img));
//           observer.complete();
//       }
//     });
//  }



  // ngOnChanges()
  // {
  //    this._examinationservice.currentMessage.subscribe(message=>this.message=message)
  //    console.log(this.message);

  //  this._examinationservice.getResultByEnrollmentNo(AppSettings.API_ENDPOINT+AppSettings.GetExamByEnrollmentNo,this.message)
  //    .subscribe(result =>{
  //   this.resultdata=result;
  //   console.table(this.resultdata);
  //   });
  // }

  
  public makePdf()  {  
   var data = document.getElementById('contentToConvert'); 
   // var data = document.getElementsByClassName('contentToConvert');
    html2canvas(data).then(canvas => {  
      // Few necessary setting options  
      var imgWidth = 190;   
      var pageHeight = 295; 
      var position = 15;    
      var imgHeight = canvas.height * imgWidth / canvas.width;  
      var heightLeft = imgHeight;  
      const contentDataURL = canvas.toDataURL('image/png')  
      let doc = new jsPDF('p', 'mm', 'a4'),
      margins = {
        top: 40,
        bottom: 60,
        left: 60,
        right:60,
        width: 522
      }; 
      // A4 size page of PDF  
       
      doc.addImage(contentDataURL, 'PNG', 10, position, imgWidth, imgHeight)  ;
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(contentDataURL, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save("Transcript "); // Generated PDF   
    });  
  }
}
